import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Component/HomePage";
import LifeSciences from "./Component/LifeSciences";
import Payer from "./Component/Payer";
import RevenueCycle from "./Component/RevenueCycle";
import WorkersComp from "./Component/WorkersComp";
import CodingServices from './Component/CodingServices';
import AbsenceManagement from './Component/AbsenceManagement';
import BillReview from './Component/BillReview';
import UtilizationManagement from './Component/UtilizationManagement';
import PatientCare from './Component/PatientCare';
import ContactUs from './Component/ContactUs';
import NursingJob from './Component/NursingJob';
import Careers from './Component/Careers';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/life-sciences" element={<LifeSciences />} />
    <Route path="/payer" element={<Payer />} />
    <Route path="/revenue-cycle" element={<RevenueCycle />} />
    <Route path="/workers-comp" element={<WorkersComp />} />
    <Route path="/coding-services" element={<CodingServices />} />
    <Route path="/absence-management" element={<AbsenceManagement />} />
    <Route path="/bill-review" element={<BillReview />} />
    <Route path="/utilization-management" element={<UtilizationManagement />} />
    <Route path="/patient-care" element={<PatientCare />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/nursing-jobs" element={<NursingJob />} />
    <Route path="/careers" element={<Careers />} />
    {/* Add more routes here as needed */}
  </Routes>
);

export default AppRoutes; 